module.exports = __webpack_public_path__ + "static/media/CTLI_6-235w.f505565b.png";